import React, { useState } from "react";

const FaceIndexingForm = ({
  onClose,
  reloadAlbumData
}: {
  onClose: () => void;
  reloadAlbumData: () => void;
}) => {
  const [isSaving, setIsSaving] = useState(false);
  const [enableFaceIndexing, setEnableFaceIndexing] = useState<boolean | null>(
    null
  );

  const updateFaceIndexing = async (successMsg: string) => {
    setIsSaving(true);
    try {
      const response = await fetch("/update_user_face_indexing", {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token":
            document
              .querySelector('meta[name="csrf-token"]')
              ?.getAttribute("content") || ""
        },
        body: JSON.stringify({ face_indexing_enabled: enableFaceIndexing })
      });
      if (!response.ok) throw new Error("Request failed");
      reloadAlbumData();
      onClose();
      // @ts-ignore
      toastr.success(successMsg);
    } catch (error) {
      onClose();
      // @ts-ignore
      toastr.error("Error updating face indexing. Please try again.");
    } finally {
      setIsSaving(false);
    }
  };

  const handleSave = () => {
    if (enableFaceIndexing !== null) {
      updateFaceIndexing(
        `Successfully ${
          enableFaceIndexing ? "enabled" : "disabled"
        } face indexing.`
      );
    } else {
      // @ts-ignore
      toastr.warning("Please select Yes or No first.");
    }
  };

  return (
    <div className="geo-form--fw geo-form--settings-rek">
      <div className="face-indexing-section">
        <label
          htmlFor="face_indexing_enabled_true"
          className="ad-us-label labelset-radio face-indexing-label"
        >
          <input
            id="face_indexing_enabled_true"
            type="radio"
            name="face_indexing_enabled"
            className="form-control input-medium"
            required
            checked={enableFaceIndexing === true}
            onChange={() => setEnableFaceIndexing(true)}
          />
          <span className="labelset-radioinput"></span>
          <span className="labelset-text">
            <strong className="labelset-title">Yes</strong>
          </span>
        </label>

        <label
          htmlFor="face_indexing_enabled_false"
          className="ad-us-label labelset-radio face-indexing-label"
        >
          <input
            id="face_indexing_enabled_false"
            type="radio"
            name="face_indexing_enabled"
            className="form-control input-medium"
            required
            checked={enableFaceIndexing === false}
            onChange={() => setEnableFaceIndexing(false)}
          />
          <span className="labelset-radioinput"></span>
          <span className="labelset-text">
            <strong className="labelset-title">No</strong>
          </span>
        </label>
      </div>
      <div className="face-indexing-warning-msg">
        This cannot be changed once the photos are uploaded
      </div>
      <button
        className="geo-btn geo-btn--secondary geo-btn--caps"
        onClick={handleSave}
        disabled={isSaving || enableFaceIndexing == null}
      >
        {isSaving ? "Saving..." : "Save and upload"}
      </button>
    </div>
  );
};

export default FaceIndexingForm;
